import { render } from "./PaginationForUser.vue?vue&type=template&id=0bd671e6&scoped=true"
import script from "./PaginationForUser.vue?vue&type=script&lang=js"
export * from "./PaginationForUser.vue?vue&type=script&lang=js"

import "./PaginationForUser.vue?vue&type=style&index=0&id=0bd671e6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\GameToGo\\Desktop\\ecommerce-movie7-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd671e6"]])

export default __exports__